/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 * @flow
 */

import slugify from 'utils/slugify';

/**
 * get the segment starting with `#` from the href string, for example,
 *  href = `http://localhost:8000/tutorial/tutorial.html#function-components`
 * it returns "#function-components"
 *
 * @param {*} href
 */
const toAnchor = (href: string = ''): string => {
  const index = href.indexOf('#');
  return index >= 0 ? href.substr(index) : '';
};

// TODO: Account for redirect_from URLs somehow; they currently won't match.
// FIXME: This comment should not be true anymore since we're using 300 redirects

type Item = {
  id: string,
  href: string,
};

/**
 * check if current item is active or not
 *
 * @param {*} location
 * @param {*} item
 */
const isItemActive = (location: Location, item: Item): boolean => {
  // location.hash: Return the anchor part of a URL. Assume that the current URL
  // is http://www.example.com/test.htm#part2, the result will be "#part2"
  if (location.hash) {
    if (item.href) {
      return location.hash === toAnchor(item.href);
    }
  } else if (item.id.includes('html')) {
    return location.pathname.includes(item.id);
  }
  const slugId = location.pathname.split('/').slice(-1)[0];
  return slugId === slugify(item.id);
};

export default isItemActive;
